import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

import { DefaultViewConfig } from '@core/types';
import { SettingGroupID } from 'types';
import { AppConfig } from 'types/AppConfig';
import getServerSetting3DRenderMode from './get3DRenderMode';

const appConfigContext = createContext(null);
const { Provider } = appConfigContext;

export const useAppConfig = () => useContext<[AppConfig]>(appConfigContext);

function AppConfigProvider({ children, value: initAppConfig }: { children: React.ReactNode; value: AppConfig }) {
	// khởi tạo default3DRenderSetting
	const serverSetting3DRender = getServerSetting3DRenderMode();
	initAppConfig.default3DRenderSetting = Object.assign(
		{},
		DefaultViewConfig[SettingGroupID.render3D], // cấu hình mặc định hardcode
		initAppConfig.default3DRenderSetting, // cấu hình theo bản build
	);
	if (serverSetting3DRender) {
		initAppConfig.default3DRenderSetting = Object.assign(initAppConfig.default3DRenderSetting, {
			renderMode: serverSetting3DRender, // cấu hình theo tham số url từ server cài đặt
		});
	}
	console.log('AppConfigProvider - default3DRenderSetting: ', initAppConfig);

	const [appConfig, _setAppConfig] = useState(initAppConfig);

	return <Provider value={[appConfig]}>{children}</Provider>;
}

AppConfigProvider.propTypes = {
	children: PropTypes.any,
	value: PropTypes.any,
};

export default AppConfigProvider;
